import { render } from "./CustomTokenList.vue?vue&type=template&id=d21bb39c&scoped=true"
import script from "./CustomTokenList.vue?vue&type=script&lang=js"
export * from "./CustomTokenList.vue?vue&type=script&lang=js"

import "./CustomTokenList.vue?vue&type=style&index=0&id=d21bb39c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21bb39c"]])

export default __exports__